/**
 * defa.views.UserVerifyEmailForm
 * A view to verify Users emails with.
 * @version 1.2.0
 */
import { defa } from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/userVerifyEmailForm.jst.html';

const api = {
	verify: defa.vars.apiHost + '/verifyemail?token=%s'
};

const selectors = {
	inputPassword: '[data-input="email-password"]',
	buttonSubmit : '[data-click="email-submit]',
	checkbox     : '[data-input=update-other-emails]'
};

const UserVerifyEmailForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template        : template,
	noInitValidation: true,
	
	ui: {
		password: selectors.inputPassword,
		checkbox: selectors.checkbox,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form
	 * @void
	 */
	submit: function () {
		
		let self = this;
		let updateOtherEmails = !!this.ui.checkbox.is(':checked');
		let url = api.verify.replace( '%s', self.options.token );
		$.ajax( {
			 url        : url,
			 method     : 'POST',
			 contentType: 'application/json',
			 data       : JSON.stringify( {
				 password: this.ui.password.val().trim(),
				 updateOtherEmails: updateOtherEmails
			 } ),
		 } )
		 .done( function ( /* response */ ) {
			 self.trigger( 'email:verified' );
		 } )
		 .fail( function ( response ) {
			 self.outputFeedback( {
				 response: response,
				 status  : 'error',
			 } );
		 } );
	},
	
} );

export default UserVerifyEmailForm;